import React, { useState, useRef, useContext, useEffect } from 'react'
import ImageGallery from 'react-image-gallery'
import 'react-image-gallery/styles/css/image-gallery.css'
import {
    Box,
    Breadcrumbs,
    Button,
    Dialog,
    IconButton,
    Modal,
    TextField,
    Tooltip,
    Typography,
} from '@material-ui/core'
import Comments from '@/custom/components/organisms/Comments'
import * as Yup from 'yup'
import { makeStyles, withStyles } from '@material-ui/core/styles'
import Accordion from '@material-ui/core/Accordion'
import AccordionSummary from '@material-ui/core/AccordionSummary'
import MuiAccordionDetails from '@material-ui/core/AccordionDetails'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import './ProductView.css'
import Buynow from '@/custom/components/molecules/Buynow/BuynowItem'
import CustomCommonContext from '@/custom/context/common/commonContext'
import ProductCommonContext from '@/product/context/common/commonContext'
import { useFormik } from 'formik'
import { dateFormatFront, currencyFormat, useCustomMediaQuery } from '@/custom/common/components'
import ProductViewFavoriteCheckbox from '@/custom/components/atoms/FavoriteCheckbox'
import ReverseBidding from '@/custom/components/molecules/Reverse/Bidding/BiddingItem'
import Timer from '@/custom/common/timer'
import Bidding from '@/custom/components/molecules/Bidding/BiddingItem'
import ProductContext from '@/product/context/product/productContext'
import AuthContext from '@/product/context/auth/authContext'
import Loaders from '@/custom/components/molecules/Loaders'
import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import { handleRedirectInternal, isValidHttpUrl } from '@/product/common/components'
import BuyerContext from '../../../../product/context/buyer/buyerContext'
import { Link, useHistory } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import SEO from '@/utils/SEO'
import { mapData } from '@/product/common/components'
import DynamicView from '@/product/components/species/dynamic/common/Product/ProductDynamic'
import Makeoffer from '@/custom/components/molecules/Makeoffer/MakeofferItem'
import AlertContext from '@/product/context/alert/alertContext'
import CustomDialog from '@/custom/components/organisms/Dialog'
import MessageContext from '@/product/context/message/messageContext'
import openSocket from 'socket.io-client'
import ProductsSlider from '@/custom/components/molecules/ProductsSlider'
import CommonContext from '@/product/context/common/commonContext'
import Share from './Share'
import { messageHandler } from '@/custom/common/socketHandler'
import Comment from '@/custom/components/organisms/Comments/comment'
import CommentContext from '@/product/context/comment/commentContext'
import NotesContext from '@/product/context/notes/notesContext'
import { NavigateNext } from '@material-ui/icons'
import SeeMoreLess from '../../molecules/SeeMoreLess'
import Login from '@/views/Login/login'
import CustomTooltip from '../CustomTooltip/CustomTooltip'
import SignContext from '@/custom/context/signContext'
let randomVariable = Math.random()
const ProductView = (props) => {
    const [manage, setManage] = useState(false)
    const [askQuestion, setAskQuestion] = useState(false)
    const [expanded, setExpanded] = useState()
    const [images, setImages] = useState([])
    const [comments, setComments] = useState([])
    const [isLoading, setIsLoading] = useState(true)
    const [swiper, setSwiper] = useState(null)
    const commonContext = useContext(CommonContext)
    const { setBidHistoryValue } = commonContext

    const productContext = useContext(ProductContext)
    const {
        search_allsimilar,
        // getAllSimilarProducts,
        search_allproducts,
        getAllSearchProducts,
        responseStatus,
    } = productContext
    const {
        saveComment,
        responseStatus: commentStatus,
        getAllComments,
        clearResponse,
    } = useContext(CommentContext)
    const {
        getNotes,
        notesAction,
        responseStatus: notesStatus,
        clearResponse: notesClearResponse,
    } = useContext(NotesContext)

    const { allLocations, alldata_all_dropdown, allConfigurationVariables, allCategory } =
        useContext(CustomCommonContext)

    const { setAlert } = useContext(AlertContext)
    const { isAuthenticated, user } = useContext(AuthContext)
    let [viewProduct, setViewProduct] = useState([])
    let [similarProducts, setSimilarProducts] = useState([])
    const [product, setProduct] = useState({})
    const [percentOff, setPercentOff] = useState(0)
    const [selectedQty, setSelectedQty] = useState(0)
    const [productLocation, setProductLocation] = useState({})
    const history = useHistory()
    const { t } = useTranslation()
    const breadcrumbs = [
        <Link underline="hover" key="1" to="/">
            Zipperbuy
        </Link>,
        <Link underline="hover" key="2" to="/search">
            All Listings
        </Link>,
        <Link underline="hover" key="3" to={`/search?category=${product.category}`}>
            {allCategory
                .filter((values) => parseInt(values.id, 10) === parseInt(product.category, 10))
                .map((values) => values.description)}
        </Link>,
        <Link underline="hover" key="4" to={`/search?category=${product.category}`}>
            {allCategory
                .filter((values) => parseInt(values.id, 10) === parseInt(product.sub_category, 10))
                .map((values) => values.description)}
        </Link>,
    ]
    const [notesQues, setNotesQues] = useState(false)
    const { handleLoginPopup } = useContext(SignContext)
    const viewProductRef = useRef(viewProduct)
    const userRef = useRef(user)
    // connsole.log(userRef, 'test')
    const search = {
        limit: 3,
        page: 1,
        orderby: 'p.id, desc',
        order: '',
        inCartCount: true,
        inCartProducts: true,
        includeSellerDetails: true,
        filters: {
            product_id: {
                value: props.data,
                type: 'in',
                field: 'p.id',
            },
            currentLocation: {
                // state: currentLocation.state,
                // city: currentLocation.city,
            },
        },
        market_status: ['open', 'sold', 'closed', 'draft', 'relisted', 'unsold'],
        inCartProducts: true,
    }
    const searchRef = useRef(search)

    const [anchorEl, setAnchorEl] = useState(null)
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget)
    }

    const handleClose = (history, path) => {
        setAnchorEl(null)
    }
    const validationSchema = Yup.object({
        notes: Yup.string().required('Please add notes'),
    })
    const isMobileView = useCustomMediaQuery('(width <= 1024px)')
    const notesFormik = useFormik({
        initialValues: {
            getUser: true,
            project_id: 0,
            notes: '',
            id: 0,
        },
        validationSchema: validationSchema,
        onSubmit: (values) => {
            notesAction(values)
            toggleNotes()
        },
    })

    useEffect(() => {
        setIsLoading(true)
        setViewProduct([])
        setProduct({})
        randomVariable = Math.random()
        getAllSearchProducts(search, randomVariable, 'custom/')
        if (props?.data > 0) {
            getAllComments({
                project_id: props.data,
            })
            notesFormik.values.project_id = parseInt(props.data || 0)
        }
    }, [props.data])

    useEffect(() => {
        if (props?.data > 0 && isAuthenticated) {
            notesFormik.values.project_id = parseInt(props.data || 0)
            getNotes({
                getUser: true,
                filters: {
                    project_id: {
                        value: props.data,
                        type: 'in',
                        field: 'upn.project_id',
                    },
                },
            })
        }
    }, [props.data, isAuthenticated])

    useEffect(() => {
        viewProductRef.current = viewProduct
        userRef.current = user
        searchRef.current = search
    })

    useEffect(() => {
        if (commentStatus) {
            if (commentStatus?.from === 'getAllComments' && commentStatus?.status === 'success') {
                setComments(commentStatus.data)
            }
        }
        clearResponse()
    }, [commentStatus])

    const projectNotes = [
        {
            label: 'Notes',
            name: 'notes',
            type: 'textarea',
            placeholder: 'Add your notes here',
            formik: notesFormik,
        },
    ]

    useEffect(() => {
        if (notesStatus && isAuthenticated) {
            if (notesStatus?.from === 'getNotes' && notesStatus?.status === 'success') {
                if (notesStatus.data?.records[0]?.id) {
                    const savedNotes = notesStatus.data?.records[0]
                    notesFormik.setFieldValue('id', savedNotes?.id)
                    notesFormik.setFieldValue('notes', savedNotes?.notes)
                    notesFormik.setFieldValue('project_id', savedNotes?.project_id)
                    notesFormik.setFieldValue('getUser', true)
                }
            }
            if (notesStatus?.from === 'notesAction' && notesStatus?.status === 'success') {
                getNotes({
                    getUser: true,
                    filters: {
                        project_id: {
                            value: props.data,
                            type: 'in',
                            field: 'upn.project_id',
                        },
                    },
                })
            }
        }
        notesClearResponse()
    }, [notesStatus])

    const handler = (message, type, noToast = false) => {
        if (type === 'productPosted' || type === 'productClosed') {
            randomVariable = Math.random()
            getAllSearchProducts(searchRef.current, randomVariable, 'custom/')
        } else {
            messageHandler(
                message,
                viewProductRef.current,
                userRef.current,
                setAlert,
                setViewProduct,
                type,
                null,
                global?.successBidMessage,
                noToast,
            )
        }
    }

    // useEffect(() => {
    //     setProduct(props.data)
    // }, [props.data])

    useEffect(() => {
        const socket = openSocket(`${process.env.REACT_APP_DOMAIN}/`, {
            transports: ['websocket'],
        })
        socket.on('realclosedupdates', (data) => {
            data['date_closed'] = new Date().toISOString()
            data['bpop_belowFiveIncrement'] = new Date().toISOString()
            handler(data, 'realclosedupdates')
        })
        socket.on('bidAddtime', (data) => {
            // if (window.location && window.location.pathname?.includes('product')) {

            handler(data, 'bidAddtime', props.isPopup || false)
            // }
        })
        socket.on('productPosted', (data) => {
            handler(data, 'productPosted')
        })
        socket.on('productClosed', (data) => {
            handler(data, 'productClosed')
        })
        socket.on('cartupdate', (data) => {
            handler(data, 'cartupdate')
        })
        socket.on('connect', function () {
            console.log('socket connect api hit 3')

            randomVariable = Math.random()
            getAllSearchProducts(searchRef.current, randomVariable, 'custom/')
        })

        socket.on('cancelBidEmitted', (data) => {
            if (
                data?.project_id &&
                viewProductRef.current?.some((product) => product?.id === data?.project_id)
            ) {
                randomVariable = Math.random()
                getAllSearchProducts(searchRef.current, randomVariable, 'custom/')
            }
        })

        return () => {
            socket.off('realclosedupdates', (data) => {
                data['date_closed'] = new Date().toISOString()
                data['bpop_belowFiveIncrement'] = new Date().toISOString()
                handler(data, 'realclosedupdates')
            })
            socket.off('bidAddtime', (data) => {
                handler(data, 'bidAddtime')
            })
            socket.off('productPosted', (data) => {
                handler(data, 'productPosted')
            })
            socket.off('productClosed', (data) => {
                handler(data, 'productClosed')
            })
            socket.off('cartupdate', (data) => {
                handler(data, 'cartupdate')
            })

            socket.off('cancelBidEmitted', (data) => {
                if (
                    data?.project_id &&
                    viewProductRef.current?.some((product) => product?.id === data?.project_id)
                ) {
                    randomVariable = Math.random()
                    getAllSearchProducts(searchRef.current, randomVariable, 'custom/')
                }
            })

            socket.disconnect()
        }
    }, [])
    const [isHardOfferSelected, setHardOffer] = useState(false)
    function toggleHardOffer(isSelected) {
        setHardOffer(!isSelected)
    }
    useEffect(() => {
        if (responseStatus) {
            if (
                responseStatus.from === 'addWatchlist' ||
                responseStatus.from === 'removeWatchlist'
            ) {
                handler(
                    {
                        id: responseStatus.data.project_id,
                        status: responseStatus.data.status,
                    },
                    'watchlistAdded',
                )
            }
        }
    }, [responseStatus])
    useEffect(() => {
        if (search_allproducts) {
            if (search_allproducts.from == randomVariable) {
                if (
                    search_allproducts?.records?.length &&
                    search_allproducts?.records[0]?.id == props.data
                ) {
                    setViewProduct(
                        search_allproducts.records.length ? search_allproducts.records : [],
                    )
                }
                setIsLoading(false)
            }
        }
    }, [search_allproducts])

    useEffect(() => {
        if (viewProduct.length && viewProduct[0].id == props.data) {
            setProduct(viewProduct[0])
        }
    }, [viewProduct])

    const [isPickOpen, setIsPickOpen] = useState(false)
    const handleOpenPickup = () => {
        setIsPickOpen(!isPickOpen)
    }

    const pickStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        width: 400,
        bgcolor: 'background.paper',
        boxShadow: 24,
        cursor: 'pointer',
        p: 2,
        borderRadius: 10,
    }

    useEffect(() => {
        if (product) {
            const allImages = []

            // if (product?.avatar) {
            //     allImages.push({
            //         original: isValidHttpUrl(product.avatar)
            //             ? product.avatar
            //             : global.images_url + product.avatar,
            //         thumbnail: isValidHttpUrl(product.avatar)
            //             ? product.avatar
            //             : global.images_url + product.avatar,
            //     })
            // }

            if (product?.allattachmentlist?.length) {
                product.allattachmentlist.forEach((data) => {
                    allImages.push({
                        original: isValidHttpUrl(data.file_name)
                            ? data.file_name
                            : global.images_url + data.file_name,
                        thumbnail: isValidHttpUrl(data.file_name)
                            ? data.file_name
                            : global.images_url + data.file_name,
                    })
                })
            }
            setImages(allImages)

            // if (product.allattachmentlist) {
            //     if (product.allattachmentlist.length) {
            //         product.allattachmentlist.forEach(function (data) {
            //             data['original'] = isValidHttpUrl(data['file_name'])
            //                 ? data['file_name']
            //                 : global.images_url + data['file_name']
            //             data['thumbnail'] = isValidHttpUrl(data['file_name'])
            //                 ? data['file_name']
            //                 : global.images_url + data['file_name']
            //         })
            //         setImages(product.allattachmentlist)
            //     } else {
            //         setImages([])
            //     }
            // } else {
            //     setImages([])
            // }

            // product qty
            // setSelectedQty(product.qty - product.sold > 0 ? product.qty - product.sold : 0)
            setSelectedQty(product.qty - product.sold > 0 ? 1 : 0)
            // setSelectedQty(product.qty - product.sold > selectedQty ? selectedQty : 0)

            if (allLocations?.length) {
                setProductLocation(
                    allLocations.filter((item) => item?.id === parseInt(product?.location))[0] ||
                        {},
                )
            }

            // if (product?.asin_price) {
            //     const buynowPrice =
            //         product?.buynow && product?.bprice ? product?.bprice : product?.wprice
            //     // const buynowPrice = product?.bprice
            //     setPercentOff(
            //         Math.round(
            //             (((product?.asin_price - buynowPrice) / product?.asin_price) * 100).toFixed(
            //                 2,
            //             ),
            //         ),
            //     )
            // }

            if (product?.asin_price) {
                let priceForDiscount = 0

                if (product?.buynowamount) {
                    priceForDiscount =
                        product?.buynowamount && product.buynowamount < product.wprice
                            ? product.wprice
                            : product?.buynowamount
                } else if (product?.bprice && product?.wprice < product?.bprice) {
                    priceForDiscount = product?.bprice
                } else {
                    priceForDiscount = product?.wprice
                }

                let percent = ((product?.asin_price - priceForDiscount) / product?.asin_price) * 100

                percent = Math.max(0, percent)

                setPercentOff(Math.round(percent))
            }
        } else {
            setImages([])
        }
    }, [product, allLocations])

    const renderCustomCartMsg = (item) => {
        return (
            <>
                {/* Main image */}
                <img src={item.original} alt="Gallery Item" className="image-gallery-image" />
                {product?.in_cart_count >= 1 ? (
                    <div className="inCart">
                        {product?.in_cart_count === 1
                            ? `${product?.in_cart_count} other has`
                            : `${product?.in_cart_count} others have`}{' '}
                        this in their cart
                    </div>
                ) : null}
            </>
        )
    }
    const renderCustomItem = (item) => {
        return (
            <div className="custom-gallery-item">
                <img src={item.original} alt="Gallery Item" className="image-gallery-image" />
                <div className="overlay">
                    <Link to={`/product-view/${product.id}`} className="tileOverlay">
                        <img src="/assets/images/sold_stamp.png" alt="Sold Product Stamp" />
                    </Link>
                    {product?.in_cart_count >= 1 ? (
                        <div className="inCart">
                            {product?.in_cart_count === 1
                                ? `${product?.in_cart_count} other has`
                                : `${product?.in_cart_count} others have`}{' '}
                            this in their cart
                        </div>
                    ) : null}
                    {/* {product.market_status === 'open' && product.source_type === null ? (
                        <Link to={`/product-view/${product.id}`} className="tileOverlay">
                            <img src="/assets/images/sold_stamp.png" alt="Sold Product Stamp" />
                        </Link>
                    ) : product.market_status !== 'open' && product.market_status !== 'sold' ? (
                        <Link to={`/product-view/${product.id}`}>
                            <div className="overOverlay"></div>
                        </Link>
                    ) : null} */}
                </div>
            </div>
        )
    }

    useEffect(() => {
        if (product?.id && !props.isPopup) {
            setIsLoading(false)
            const search = {
                limit: 7,
                page: 1,
                orderby: 'bid_count, desc',
                order: '',
                similars: {
                    category: {
                        value: [],
                        type: 'array',
                        field: 'it.category',
                    },
                    condition: {
                        value: [],
                        type: 'array',
                        field: 'it.conditionTypeId',
                    },
                    location: {
                        value: [],
                        type: 'array',
                        field: 'p.location_id',
                    },
                    auctionid: {
                        value: [],
                        type: 'array',
                        field: 'p.auctionid',
                    },
                },
                filterBid: true,
                // having: {
                //     bid_count: {
                //         value: '0',
                //         type: 'notin',
                //         field: 'bid_count',
                //     },
                // },
                filters: {
                    product_id: {
                        value: product.id,
                        type: 'notin',
                        field: 'p.id',
                    },
                    category: {
                        value: '',
                        type: 'in',
                        field: 'it.category',
                    },
                },
            }

            if (product.category) {
                search.similars.category.value.push(product.category)
            }
            if (product.category) {
                search.filters.category.value = product.category
            }
            // if (product.conditionTypeId) {
            //     search.similars.condition.value.push(product.conditionTypeId)
            // }

            if (product.location_id) {
                search.similars.location.value.push(product.location_id)
            }

            if (product.auctionid) {
                search.similars.auctionid.value.push(product.auctionid)
            }

            // getAllSimilarProducts(search)
            getAllSearchProducts(search, 'similar-product', 'custom/')
        }
    }, [product?.id])

    // useEffect(() => {
    //     if (search_allsimilar) {
    //         setSimilarProducts(search_allsimilar?.records?.length ? search_allsimilar.records : [])
    //     }
    // }, [search_allsimilar, product])

    console.log('search_allproducts', search_allproducts)
    useEffect(() => {
        if (search_allproducts && search_allproducts.from == 'similar-product') {
            setSimilarProducts(
                search_allproducts?.records?.length ? search_allproducts.records : [],
            )
        }
    }, [search_allproducts, product])

    const AccordionDetails = withStyles((theme) => ({
        root: {
            padding: '10px',
        },
    }))(MuiAccordionDetails)

    {
        /*useEffect(() => {
        if (responseStatusBid) {
            if (responseStatusBid.from === 'bidCancel') {
                if (responseStatusBid.status === 'success') {
                    getAllBidHistory({
                        limit: 10,
                        page: 1,
                        id: product?.id,
                    })
                    setAlert(responseStatusBid.message, 'success')
                    clearResponseBid()
                } else {
                    setAlert(responseStatusBid.message, 'error')
                    clearResponseBid()
                }
            }
        }
    }, [responseStatusBid]) */
    }

    const cancelBid = () => {
        if (search_allbidhistory?.records?.length > 0) {
            let topValid = search_allbidhistory.records.find((bid) => bid.declined === 0)
            bidCancel({ id: topValid.bidid })
        }
    }
    const formatDate = (dateString) => {
        const date = new Date(dateString)
        const options = {
            year: '2-digit',
            month: '2-digit',
            day: '2-digit',
            hour: 'numeric',
            minute: '2-digit',
            hour12: true,
            timeZone: 'America/New_York',
            timeZoneName: 'short',
        }
        return new Intl.DateTimeFormat('en-US', options).format(date)
    }
    const isBidCanceAllowed = () => {
        let diff = 0
        if (product.date_closed) {
            diff = new Date(product.date_closed).getTime() - new Date().getTime()
        }
        let allowed = product.custom_auctionlot_bid_retract_minutes * 60 * 1000
        return (
            product.custom_auctionlot_bid_retract_check === 1 &&
            product.custom_auctionlot_bid_retract_minutes > 0 &&
            search_allbidhistory.records?.length > 0 &&
            diff > 0 &&
            diff > allowed
        )
    }

    const substractMinutes = (date, minutes) => {
        const d = new Date(date)
        const newTime = d.getTime() - minutes * 60 * 1000
        const newDate = new Date(newTime)
        return newDate.toISOString()
    }

    const handleChange = (panel) => (event, newExpanded) => {
        setExpanded(newExpanded ? panel : false)
    }
    const closePopUp = () => {
        setManage(false)
        formik.handleReset()
    }
    const handleMessageSubmit = async (values) => {
        let messageFormData = {
            ...values,
            attachinsidename: '',
            attachorginalname: '',
            sellermsgpost: product.user_id,
            status: 'open',
            user_id: user.id,
            projectmsgpost: product.id,
        }

        saveMessage(messageFormData)
    }
    const formik = useFormik({
        initialValues: {
            message: '',
        },

        onSubmit: (values) => {
            handleMessageSubmit(values)
            setManage(false)
            formik.handleReset()
        },
    })

    const message = []
    message.push({
        label: 'Message',
        placeholder: `Type message to admin`,
        class: 'col-md-12',
        name: 'message',
        formik: formik,
    })

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' })
    }, [window.location.pathname])

    const toggleQuestion = () => setAskQuestion(!askQuestion)
    const toggleNotes = () => setNotesQues(!notesQues)
    const deleteNotes = () => {
        notesFormik.setFieldValue('notes', '')
        notesAction({
            id: notesFormik.values.id,
            notes: '',
        })
    }
    const research = () => {
        if (product?.asin_id && product.asin_id !== '') {
            window.open(`https://www.amazon.com/dp/${product.asin_id}`, '_blank')
        } else {
            window.open(`https://www.google.com/search?q=${product.title}`, '_blank')
        }
    }

    const galleryRef = useRef(null)
    const [updateThumnailCount, setUpdateThumnailCount] = useState(null)
    const totalCount = galleryRef.current ? galleryRef.current.props.items.length : 0
    useEffect(() => {
        setUpdateThumnailCount(totalCount)
    }, [totalCount])

    // const getTotalSlides = () => {
    //     return galleryRef.current ? galleryRef.current.props.items.length : 0
    // }

    return (
        <>
            {/* <SEO title="Auction View" url={window.location.href} /> */}
            <div className="productView" id="productView">
                {manage && (
                    <CustomDialog
                        title={
                            <div className="d-flex align-items-center justify-content-between">
                                Message
                                <IconButton onClick={() => closePopUp(false)}>
                                    <span className="material-icons">clear</span>
                                </IconButton>
                            </div>
                        }
                        open={manage}
                    >
                        <form>
                            <div className="row mb-4">{Object.values(mapData(message))}</div>
                            <div className="actionWrapper">
                                <PrimaryButton
                                    onClick={formik.handleSubmit}
                                    id="confirm_bid_submit"
                                    type="button"
                                    label={'Submit'}
                                />
                            </div>
                        </form>
                    </CustomDialog>
                )}
                <div className="container">
                    {isLoading ? (
                        <>
                            <Loaders name="product_view" isLoading={isLoading} loop={1} />
                        </>
                    ) : product?.id ? (
                        <>
                            <div
                                className={`pvr-top breadCrumbs ${
                                    !product.bidtopstatus ? 'mb-4' : 'mb-5'
                                }`}
                            >
                                <Breadcrumbs
                                    separator={<NavigateNext fontSize="small" />}
                                    aria-label="breadcrumb"
                                >
                                    {breadcrumbs}
                                </Breadcrumbs>
                                {/* <Button
                                    onClick={() => {
                                        history.goBack()
                                        window.scrollTo(0, 0)
                                    }}
                                    className="moveBack"
                                >
                                    <span className="material-icons">keyboard_arrow_left</span>
                                    {'back'}
                                </Button> */}
                                {/* <div className="pvr-top-right">
                                    <a>
                                        <img
                                            src="/assets/svg/printer-small.svg"
                                            alt=""
                                            onClick={() => window.print()}
                                        />
                                        Print Page
                                    </a>
                                </div> */}
                            </div>
                            <div className="product-view-wrapper">
                                <div
                                    className={`pvLt ${
                                        props.isPopup && product.bidtopstatus ? 'mt-4' : ''
                                    }`}
                                >
                                    <ImageGallery
                                        ref={galleryRef}
                                        items={images}
                                        renderItem={
                                            product.market_status === 'sold'
                                                ? product.source_type === 'buynow' ||
                                                  product?.buynow_source_type === 'buynow'
                                                    ? renderCustomItem
                                                    : undefined
                                                : renderCustomCartMsg
                                        } // Use custom item renderer
                                        thumbnailPosition="bottom"
                                        showNav={true}
                                        onErrorImageURL="/assets/images/noImage.png"
                                        showBullets={false}
                                        thumbnailLoading="lazy"
                                        // thumbnailWidth={200}
                                        slideOnThumbnailOver={true}
                                        showFullscreenButton={true}
                                        useBrowserFullscreen={false}
                                        showPlayButton={false}
                                        useTranslate3D={false}
                                        additionalClass={
                                            updateThumnailCount > 4
                                                ? 'navHandler'
                                                : updateThumnailCount == 1
                                                ? 'oneItem'
                                                : ''
                                        }
                                    />
                                    {notesFormik.values.id && notesFormik.values.notes !== '' ? (
                                        <div className="madeNotes">You made notes!</div>
                                    ) : null}
                                    {isAuthenticated && (
                                        <div className="performanceStatus">
                                            {product.bidtopstatus === 'outbid' && (
                                                <div className="pvBidStatus">
                                                    <h3 className="outbid">{t('LOSING')}</h3>
                                                </div>
                                            )}
                                            {/* product.wprice >= product.rprice && */}
                                            {product.bidtopstatus === 'winner' && (
                                                <div className="pvBidStatus">
                                                    <h3 className="winning reserve">
                                                        {t('WINNING')}
                                                    </h3>
                                                </div>
                                            )}
                                            {product.bidtopstatus === 'won' && (
                                                <div className="pvBidStatus">
                                                    <h4 className="won">
                                                        {t(
                                                            // 'Congratulations you have won this item',
                                                            'WON',
                                                        )}
                                                    </h4>
                                                </div>
                                            )}
                                            {product.bidtopstatus === 'lost' && (
                                                <div className="pvBidStatus">
                                                    <h4 className="lost">{t('LOST')}</h4>
                                                </div>
                                            )}
                                        </div>
                                    )}
                                    {/* {product && (
                                        <div
                                            className={`onlineschBtn ${
                                                isAuthenticated ? '' : 'notLoggedIn'
                                            }`}
                                        >
                                            <PrimaryButton
                                                id="research_product_online"
                                                label="Research Product Online"
                                                onClick={() => research()}
                                            />
                                        </div>
                                    )} */}
                                </div>

                                <div className="pvRt">
                                    <>
                                        <div className="productDescr">
                                            <div className="pvProductInfo mb-1 d-flex align-items-start">
                                                <h2 className="pv-pro-title">{product.title}</h2>

                                                {isMobileView ? null : (
                                                    <div className="pvr-top">
                                                        <Share
                                                            anchorEl={anchorEl}
                                                            handleClose={handleClose}
                                                            handleClick={handleClick}
                                                            title={product.title}
                                                            id={product.id}
                                                        />
                                                        {isAuthenticated ? (
                                                            product?.market_status == 'open' ? (
                                                                <div className="pvr-top-right">
                                                                    <div className="fav-wrap">
                                                                        <ProductViewFavoriteCheckbox
                                                                            watchlisted={
                                                                                product.watchlistid
                                                                            }
                                                                            project_id={product.id}
                                                                            add_watchlist_message={
                                                                                'Added to Favorites'
                                                                            }
                                                                            remove_watchlist_message={
                                                                                'Removed from Favorites'
                                                                            }
                                                                        />
                                                                    </div>
                                                                </div>
                                                            ) : null
                                                        ) : (
                                                            <div
                                                                className="favoriteCheck beforeAuthFav qqq"
                                                                onClick={handleLoginPopup}
                                                            >
                                                                <span className="material-icons ntChckd">
                                                                    favorite_border
                                                                </span>
                                                            </div>
                                                        )}
                                                    </div>
                                                )}
                                            </div>
                                            <div className="retAmount d-flex align-items-center my-md-4 my-1 asd">
                                                {product.buynowamount ? (
                                                    <>
                                                        {percentOff ? (
                                                            <>
                                                                <div
                                                                    className={
                                                                        product.asin_price !== 0
                                                                            ? 'retailAmnt'
                                                                            : 'd-none'
                                                                    }
                                                                >
                                                                    {currencyFormat(
                                                                        product.asin_price,
                                                                    )}
                                                                </div>
                                                            </>
                                                        ) : null}
                                                        <div className="currentAmount">
                                                            {/* {currencyFormat(product.buynowamount)} */}
                                                            {currencyFormat(
                                                                product?.buynowamount &&
                                                                    product.buynowamount <
                                                                        product.wprice
                                                                    ? product.wprice
                                                                    : product?.buynowamount ||
                                                                          product.wprice,
                                                            )}
                                                        </div>{' '}
                                                        {product?.asin_price && percentOff > 0 ? (
                                                            <>
                                                                {product?.wprice <
                                                                product?.asin_price ? (
                                                                    <div className="currentOffer">
                                                                        {percentOff}% off
                                                                    </div>
                                                                ) : (
                                                                    ''
                                                                )}
                                                            </>
                                                        ) : null}
                                                    </>
                                                ) : (
                                                    <>
                                                        {percentOff ? (
                                                            <>
                                                                <div
                                                                    className={
                                                                        product.asin_price !== 0
                                                                            ? 'retailAmnt'
                                                                            : 'd-none'
                                                                    }
                                                                >
                                                                    {currencyFormat(
                                                                        product.asin_price,
                                                                    )}
                                                                </div>
                                                            </>
                                                        ) : (
                                                            <div className="currentAmount currentPrice">
                                                                {currencyFormat(product.wprice)}
                                                            </div>
                                                        )}
                                                        {product.wprice < product.bprice &&
                                                        product?.asin_price ? (
                                                            <div className="currentAmount buyNowAMount">
                                                                {currencyFormat(product.bprice)}
                                                            </div>
                                                        ) : percentOff > 0 &&
                                                          product?.asin_price ? (
                                                            <div className="currentAmount buyNowAMount">
                                                                {currencyFormat(product.wprice)}
                                                            </div>
                                                        ) : null}
                                                        {product?.asin_price && percentOff > 0 ? (
                                                            <>
                                                                {product?.wprice <
                                                                product?.asin_price ? (
                                                                    <div className="currentOffer">
                                                                        {percentOff}% off
                                                                    </div>
                                                                ) : (
                                                                    ''
                                                                )}
                                                            </>
                                                        ) : null}
                                                    </>
                                                )}
                                                {isMobileView && (
                                                    <div className="pvr-top ml-auto">
                                                        <Share
                                                            anchorEl={anchorEl}
                                                            handleClose={handleClose}
                                                            handleClick={handleClick}
                                                            title={product.title}
                                                            id={product.id}
                                                        />
                                                        {isAuthenticated ? (
                                                            <div className="pvr-top-right">
                                                                <div className="fav-wrap">
                                                                    <ProductViewFavoriteCheckbox
                                                                        watchlisted={
                                                                            product.watchlistid
                                                                        }
                                                                        project_id={product.id}
                                                                        add_watchlist_message={
                                                                            'Added to Favorites'
                                                                        }
                                                                        remove_watchlist_message={
                                                                            'Removed from Favorites'
                                                                        }
                                                                    />
                                                                </div>
                                                            </div>
                                                        ) : (
                                                            <div
                                                                className="favoriteCheck beforeAuthFav"
                                                                onClick={handleLoginPopup}
                                                            >
                                                                <span className="material-icons ntChckd">
                                                                    favorite_border
                                                                </span>
                                                            </div>
                                                        )}
                                                    </div>
                                                )}
                                            </div>
                                            {/* <p className="pro-location">
                                                {productLocation?.name || ''}
                                            </p> */}
                                            {/* {isAuthenticated && (
                                                <>
                                                    {product.bidtopstatus === 'outbid' && (
                                                        <div className="pvBidStatus">
                                                            <h3 className="outbid">
                                                                {t('Oops you have been outbid')}.
                                                            </h3>
                                                        </div>
                                                    )}
                                                    {product.bidtopstatus === 'winner' && (
                                                        <div className="pvBidStatus">
                                                            {product?.wprice < product?.rprice ? (
                                                                <h3 className="winning reserve">
                                                                    {t(
                                                                        'Congratulations! You are the highest bidder, but the reserve price has not been met',
                                                                    )}
                                                                    .
                                                                </h3>
                                                            ) : (
                                                                <h3 className="winning">
                                                                    {t(
                                                                        'Yayy you are winning this item',
                                                                    )}
                                                                    .
                                                                </h3>
                                                            )}
                                                        </div>
                                                    )}
                                                    {product.bidtopstatus === 'won' && (
                                                        <div className="pvBidStatus">
                                                            <h4 className="won">
                                                                {t(
                                                                    'Congratulations you have won this item',
                                                                )}
                                                            </h4>
                                                        </div>
                                                    )}
                                                    {product.bidtopstatus === 'lost' && (
                                                        <div className="pvBidStatus">
                                                            <h4 className="lost">
                                                                {t(
                                                                    'Unfortunately you have lost this item',
                                                                )}
                                                            </h4>
                                                        </div>
                                                    )}
                                                </>
                                            )} */}

                                            <div className="pvActBtn productDescr">
                                                {' '}
                                                {product?.disclaimer ? (
                                                    <p className="disclaimer">
                                                        {product?.disclaimer}{' '}
                                                    </p>
                                                ) : null}
                                                <SeeMoreLess
                                                    content={product.desc_proc}
                                                    limit={isMobileView ? 100 : 155}
                                                />
                                                {/* <div
                                                    dangerouslySetInnerHTML={{
                                                        __html: product.desc_proc,
                                                    }}
                                                    className="pv-pro-descp"
                                                ></div> */}
                                            </div>

                                            {/* <div className="pvActBtn d-flex align-items-center asd">
                                                {product.market_status === 'open' ? (
                                                    <>
                                                        {product.buynow &&
                                                        product.wprice < product.bprice ? (
                                                            <div className="pabChild">
                                                                <h4>
                                                                    {currencyFormat(product.bprice)}
                                                                </h4>
                                                                <label>
                                                                    {t('Buy Now Price')}{' '}
                                                                    <img src="/assets/svg/Info.svg" />
                                                                </label>
                                                            </div>
                                                        ) : (
                                                            ''
                                                        )}

                                                        {product.auction ? (
                                                            <>
                                                                <div className="pabChild pvCurrentBid">
                                                                    <h4>
                                                                        {currencyFormat(
                                                                            product.wprice,
                                                                        )}
                                                                    </h4>
                                                                    <label>
                                                                        {product.cbidtext}
                                                                    </label>
                                                                </div>
                                                                <div className="pabChild">
                                                                    <h4>
                                                                        {currencyFormat(
                                                                            product.asin_price,
                                                                        )}
                                                                    </h4>
                                                                    <label>
                                                                        {t('Retail Value')}
                                                                    </label>
                                                                </div>{' '}
                                                            </>
                                                        ) : (
                                                            ''
                                                        )}
                                                    </>
                                                ) : product.buynowamount ? (
                                                    <>
                                                        <div className="pabChild pvCurrentBid">
                                                            <h4>
                                                                {currencyFormat(
                                                                    product.buynowamount,
                                                                )}
                                                            </h4>
                                                            <label>{product.cbidtext}</label>
                                                        </div>
                                                    </>
                                                ) : null}
                                            </div> */}
                                            <div className="pickup-wrapper mt-3">
                                                <div className="pvBidBox ml-auto">
                                                    {/* {product.makeoffer ? (
                                                            <Makeoffer
                                                                data={product}
                                                                minimumAmount={product.next_bid}
                                                            />
                                                        ) : (
                                                            ''
                                                        )} */}
                                                    {product.market_status === 'open' &&
                                                    !product.future_active ? (
                                                        <>
                                                            {product.buynow &&
                                                            !product.cart_removed &&
                                                            product.bprice >= product.wprice &&
                                                            product?.user_id !== user?.admin_id ? (
                                                                <div className="d-flex position-relative">
                                                                    <Buynow
                                                                        data={product}
                                                                        selectedQty={selectedQty}
                                                                        editQuantity={true}
                                                                        removeQuantityField={true}
                                                                        productLocation={
                                                                            productLocation
                                                                        }
                                                                        isOnlyBuynow={
                                                                            product.auction === 0
                                                                                ? true
                                                                                : false
                                                                        }
                                                                    />
                                                                </div>
                                                            ) : (
                                                                ''
                                                            )}
                                                            {product.auction &&
                                                            product?.user_id !== user?.admin_id ? (
                                                                <>
                                                                    {product.auctiontype ==
                                                                    'reverse' ? (
                                                                        <>
                                                                            <ReverseBidding
                                                                                data={product}
                                                                                type="proxy"
                                                                            />{' '}
                                                                            <ReverseBidding
                                                                                data={product}
                                                                                type="hard"
                                                                                disabled={
                                                                                    product?.market_status !==
                                                                                    'open'
                                                                                }
                                                                            />
                                                                        </>
                                                                    ) : (
                                                                        <>
                                                                            {product.custom_auctionlot_bid_type ===
                                                                            'hard' ? (
                                                                                <>
                                                                                    <Bidding
                                                                                        data={
                                                                                            product
                                                                                        }
                                                                                        type={
                                                                                            'hard'
                                                                                        }
                                                                                        disabled={
                                                                                            product?.market_status ===
                                                                                                'sold' &&
                                                                                            (product?.source_type ===
                                                                                                'buynow' ||
                                                                                                product?.buynow_source_type ===
                                                                                                    'buynow')
                                                                                        }
                                                                                    />{' '}
                                                                                </>
                                                                            ) : product.custom_auctionlot_bid_type ===
                                                                              'proxy' ? (
                                                                                <>
                                                                                    <Bidding
                                                                                        data={
                                                                                            product
                                                                                        }
                                                                                        type={
                                                                                            'proxy'
                                                                                        }
                                                                                    />{' '}
                                                                                </>
                                                                            ) : (
                                                                                <>
                                                                                    <Bidding
                                                                                        data={
                                                                                            product
                                                                                        }
                                                                                        type={
                                                                                            'proxy'
                                                                                        }
                                                                                        disabled={
                                                                                            product?.market_status ==
                                                                                            'sold'
                                                                                        }
                                                                                    />

                                                                                    <div
                                                                                        className={`timeBidding d-flex justify-content-between flex-wrap align-items-center ${
                                                                                            isHardOfferSelected &&
                                                                                            'flex-column-reverse position-relative'
                                                                                        }`}
                                                                                    >
                                                                                        <div
                                                                                            className={`mt-0 timerConTent ${
                                                                                                isHardOfferSelected &&
                                                                                                'timerAfClass'
                                                                                            }`}
                                                                                        >
                                                                                            {product.market_status ===
                                                                                            'open' ? (
                                                                                                <div className="gridTimer">
                                                                                                    <img src="/assets/svg/timer.svg" />
                                                                                                    <Timer
                                                                                                        date_added={
                                                                                                            product.date_added
                                                                                                        }
                                                                                                        date_closed={
                                                                                                            product.date_closed
                                                                                                        }
                                                                                                        withText={
                                                                                                            1
                                                                                                        }
                                                                                                        endText="Time Left: "
                                                                                                        startText="Starts in: "
                                                                                                    ></Timer>
                                                                                                </div>
                                                                                            ) : (
                                                                                                <div className="gridTimer">
                                                                                                    <img src="/assets/svg/timer-gray.svg" />
                                                                                                    <label>
                                                                                                        Closed
                                                                                                    </label>
                                                                                                </div>
                                                                                            )}
                                                                                            <div className="dateTime mt-2 text-left">
                                                                                                (
                                                                                                {formatDate(
                                                                                                    product.date_closed,
                                                                                                )}
                                                                                                )
                                                                                            </div>
                                                                                        </div>
                                                                                        <div
                                                                                            className={`${
                                                                                                isHardOfferSelected &&
                                                                                                'w-100'
                                                                                            } ${
                                                                                                isMobileView &&
                                                                                                'w-100'
                                                                                            } biddingCounter`}
                                                                                        >
                                                                                            <Bidding
                                                                                                data={
                                                                                                    product
                                                                                                }
                                                                                                type={
                                                                                                    'hard'
                                                                                                }
                                                                                                mobileViewLayout={
                                                                                                    isMobileView
                                                                                                        ? true
                                                                                                        : false
                                                                                                }
                                                                                                productHard={
                                                                                                    toggleHardOffer
                                                                                                }
                                                                                                disabled={
                                                                                                    product?.market_status ===
                                                                                                        'sold' &&
                                                                                                    (product?.source_type ===
                                                                                                        'buynow' ||
                                                                                                        product?.buynow_source_type ===
                                                                                                            'buynow')
                                                                                                }
                                                                                            />
                                                                                            <div
                                                                                                className="pick-left-wrap d-flex justify-content-end"
                                                                                                style={{
                                                                                                    minHeight:
                                                                                                        isMobileView
                                                                                                            ? null
                                                                                                            : '37px',
                                                                                                }}
                                                                                            >
                                                                                                {/* <div className="cart-qty">
                                                                                                    <label>Qty:</label>
                                                                                                        <select
                                                                                                            value={selectedQty}
                                                                                                            onChange={(e) =>
                                                                                                                setSelectedQty(e?.target?.value || 0)
                                                                                                            }
                                                                                                        >
                                                                                                            {Array.from(
                                                                                                                {
                                                                                                                    length:
                                                                                                                        product.qty - product.sold > 0
                                                                                                                            ? product.qty - product.sold
                                                                                                                            : 0,
                                                                                                                },
                                                                                                                (_, index) => (
                                                                                                                    <option
                                                                                                                        key={index + 1}
                                                                                                                        value={index + 1}
                                                                                                                    >
                                                                                                                        {index + 1}
                                                                                                                    </option>
                                                                                                                ),
                                                                                                            )}
                                                                                                        </select>
                                                                                                    </div> */}

                                                                                                {/* <a  className="get-directions-link"
                                                                                                    target="_blank"
                                                                                                    href={`https://www.google.com/maps/place/?q=place_id:${
                                                                                                        productLocation?.place_id || ''
                                                                                                    }`}
                                                                                                    rel="noreferrer"
                                                                                                >
                                                                                                    Get directions
                                                                                                </a> */}
                                                                                                {isAuthenticated ? (
                                                                                                    <>
                                                                                                        {product.bidtopstatus ===
                                                                                                            'winner' &&
                                                                                                            isBidCanceAllowed() && (
                                                                                                                <>
                                                                                                                    <div>
                                                                                                                        <div className="text-right mt-2">
                                                                                                                            <Timer
                                                                                                                                date_added={
                                                                                                                                    search_allbidhistory
                                                                                                                                        .records[0]
                                                                                                                                        .created_at
                                                                                                                                }
                                                                                                                                date_closed={substractMinutes(
                                                                                                                                    product.date_closed,
                                                                                                                                    product.custom_auctionlot_bid_retract_minutes,
                                                                                                                                )}
                                                                                                                                withText={
                                                                                                                                    1
                                                                                                                                }
                                                                                                                                endText="Cancel By: "
                                                                                                                                startText="Starts in: "
                                                                                                                                closedText="Cancellation Expired"
                                                                                                                            ></Timer>
                                                                                                                        </div>

                                                                                                                        <Button
                                                                                                                            className="pvBidHistBtn btn my-2"
                                                                                                                            onClick={() =>
                                                                                                                                cancelBid()
                                                                                                                            }
                                                                                                                        >
                                                                                                                            <span className="material-icons">
                                                                                                                                undo
                                                                                                                            </span>{' '}
                                                                                                                            {
                                                                                                                                'Cancel My Offer'
                                                                                                                            }
                                                                                                                        </Button>
                                                                                                                    </div>
                                                                                                                </>
                                                                                                            )}
                                                                                                        {isMobileView ? null : (
                                                                                                            <>
                                                                                                                {product.auction ? (
                                                                                                                    <Button
                                                                                                                        id="view_bid_history"
                                                                                                                        className="pvBidHistBtn"
                                                                                                                        onClick={() =>
                                                                                                                            setBidHistoryValue(
                                                                                                                                product.id,
                                                                                                                            )
                                                                                                                        }
                                                                                                                    >
                                                                                                                        <img
                                                                                                                            className="mr-2"
                                                                                                                            src="/assets/svg/Gavel.svg"
                                                                                                                        />{' '}
                                                                                                                        {t(
                                                                                                                            'offer history',
                                                                                                                        )}
                                                                                                                    </Button>
                                                                                                                ) : (
                                                                                                                    ''
                                                                                                                )}
                                                                                                            </>
                                                                                                        )}
                                                                                                    </>
                                                                                                ) : (
                                                                                                    <>

                                                                                                    </>
                                                                                                )}
                                                                                            </div>
                                                                                            {/* <div className="bid-counts">
                                                                                                    <img src="/assets/svg/Gavel.svg" />
                                                                                                    {
                                                                                                        product.bid_count
                                                                                                    }{' '}
                                                                                                    {
                                                                                                        'Offers'
                                                                                                    }
                                                                                                </div> */}
                                                                                        </div>
                                                                                    </div>
                                                                                </>
                                                                            )}
                                                                        </>
                                                                    )}
                                                                </>
                                                            ) : null}
                                                        </>
                                                    ) : product.market_status === 'sold' ? (
                                                        <>
                                                            <div className="d-flex position-relative asdasd">
                                                                <Buynow
                                                                    data={product}
                                                                    selectedQty={selectedQty}
                                                                    editQuantity={true}
                                                                    removeQuantityField={true}
                                                                    productLocation={
                                                                        productLocation
                                                                    }
                                                                    isOnlyBuynow={
                                                                        product.auction === 0
                                                                            ? true
                                                                            : false
                                                                    }
                                                                    disabled={
                                                                        product?.market_status ===
                                                                            'sold' &&
                                                                        (product?.source_type ===
                                                                            'buynow' ||
                                                                            product?.buynow_source_type ===
                                                                                'buynow')
                                                                    }
                                                                />
                                                            </div>
                                                            <div className="position-relative">
                                                                <>
                                                                    {product.custom_auctionlot_bid_type ===
                                                                    'hard' ? (
                                                                        <>
                                                                            <Bidding
                                                                                data={product}
                                                                                type={'hard'}
                                                                                disabled={
                                                                                    product?.market_status ===
                                                                                        'sold' &&
                                                                                    (product?.source_type ===
                                                                                        'buynow' ||
                                                                                        product?.buynow_source_type ===
                                                                                            'buynow')
                                                                                }
                                                                            />{' '}
                                                                        </>
                                                                    ) : product.custom_auctionlot_bid_type ===
                                                                      'proxy' ? (
                                                                        <Bidding
                                                                            data={product}
                                                                            type={'proxy'}
                                                                            disabled={
                                                                                product?.market_status ===
                                                                                    'sold' &&
                                                                                (product?.source_type ===
                                                                                    'buynow' ||
                                                                                    product?.buynow_source_type ===
                                                                                        'buynow')
                                                                            }
                                                                        />
                                                                    ) : (
                                                                        <>
                                                                            <Bidding
                                                                                data={product}
                                                                                type={'proxy'}
                                                                                disabled={
                                                                                    product?.market_status ==
                                                                                    'sold'
                                                                                }
                                                                            />
                                                                            <div
                                                                                className={`timeBidding d-flex justify-content-between flex-wrap align-items-center ${
                                                                                    isMobileView &&
                                                                                    'flex-column-reverse'
                                                                                }  ${
                                                                                    isHardOfferSelected &&
                                                                                    'flex-column-reverse position-relative'
                                                                                }`}
                                                                            >
                                                                                <div
                                                                                    className={`mt-0 timerConTent ${
                                                                                        isHardOfferSelected &&
                                                                                        'timerAfClass'
                                                                                    }`}
                                                                                >
                                                                                    <div className="gridTimer">
                                                                                        <img src="/assets/svg/timer-gray.svg" />
                                                                                        <label>
                                                                                            Closed
                                                                                        </label>
                                                                                    </div>

                                                                                    <div className="dateTime mt-2 text-left">
                                                                                        (
                                                                                        {formatDate(
                                                                                            product.date_closed,
                                                                                        )}
                                                                                        )
                                                                                    </div>
                                                                                </div>
                                                                                <div
                                                                                    className={`asdasd ${
                                                                                        isHardOfferSelected &&
                                                                                        'w-100'
                                                                                    } ${
                                                                                        isMobileView &&
                                                                                        'w-100'
                                                                                    } biddingCounter`}
                                                                                >
                                                                                    <Bidding
                                                                                        data={
                                                                                            product
                                                                                        }
                                                                                        type={
                                                                                            'hard'
                                                                                        }
                                                                                        mobileViewLayout={
                                                                                            isMobileView
                                                                                                ? true
                                                                                                : false
                                                                                        }
                                                                                        productHard={
                                                                                            toggleHardOffer
                                                                                        }
                                                                                        disabled={
                                                                                            (product?.market_status ===
                                                                                                'sold' &&
                                                                                                (product?.source_type ===
                                                                                                    'buynow' ||
                                                                                                    product?.buynow_source_type ===
                                                                                                        'buynow')) ||
                                                                                            product?.market_status !==
                                                                                                'open'
                                                                                        }
                                                                                    />
                                                                                    <div
                                                                                        className="pick-left-wrap d-flex justify-content-end"
                                                                                        style={{
                                                                                            minHeight:
                                                                                                isMobileView
                                                                                                    ? null
                                                                                                    : '37px',
                                                                                        }}
                                                                                    >
                                                                                        {isAuthenticated ? (
                                                                                            <>
                                                                                                {product.bidtopstatus ===
                                                                                                    'winner' &&
                                                                                                    isBidCanceAllowed() && (
                                                                                                        <>
                                                                                                            <div>
                                                                                                                <div className="text-right mt-2">
                                                                                                                    <Timer
                                                                                                                        date_added={
                                                                                                                            search_allbidhistory
                                                                                                                                .records[0]
                                                                                                                                .created_at
                                                                                                                        }
                                                                                                                        date_closed={substractMinutes(
                                                                                                                            product.date_closed,
                                                                                                                            product.custom_auctionlot_bid_retract_minutes,
                                                                                                                        )}
                                                                                                                        withText={
                                                                                                                            1
                                                                                                                        }
                                                                                                                        endText="Cancel By: "
                                                                                                                        startText="Starts in: "
                                                                                                                        closedText="Cancellation Expired"
                                                                                                                    ></Timer>
                                                                                                                </div>

                                                                                                                <Button
                                                                                                                    className="pvBidHistBtn btn my-2"
                                                                                                                    onClick={() =>
                                                                                                                        cancelBid()
                                                                                                                    }
                                                                                                                >
                                                                                                                    <span className="material-icons">
                                                                                                                        undo
                                                                                                                    </span>{' '}
                                                                                                                    {
                                                                                                                        'Cancel My Offer'
                                                                                                                    }
                                                                                                                </Button>
                                                                                                            </div>
                                                                                                        </>
                                                                                                    )}
                                                                                                {isMobileView ? null : (
                                                                                                    <>
                                                                                                        {product.auction ? (
                                                                                                            <Button
                                                                                                                id="view_bid_history"
                                                                                                                className="pvBidHistBtn"
                                                                                                                onClick={() =>
                                                                                                                    setBidHistoryValue(
                                                                                                                        product.id,
                                                                                                                    )
                                                                                                                }
                                                                                                            >
                                                                                                                <img
                                                                                                                    className="mr-2"
                                                                                                                    src="/assets/svg/Gavel.svg"
                                                                                                                />{' '}
                                                                                                                {t(
                                                                                                                    'offer history',
                                                                                                                )}
                                                                                                            </Button>
                                                                                                        ) : (
                                                                                                            ''
                                                                                                        )}
                                                                                                    </>
                                                                                                )}
                                                                                            </>
                                                                                        ) : (
                                                                                            <></>
                                                                                        )}
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </>
                                                                    )}
                                                                </>
                                                            </div>
                                                        </>
                                                    ) : product.market_status === 'closed' ||
                                                      product.market_status === 'relisted' ||
                                                      product.market_status === 'unsold' ? (
                                                        <>
                                                            <div className="d-flex position-relative asdasd">
                                                                {/* <Buynow
                                                                    data={product}
                                                                    selectedQty={selectedQty}
                                                                    editQuantity={true}
                                                                    removeQuantityField={true}
                                                                    productLocation={
                                                                        productLocation
                                                                    }
                                                                    isOnlyBuynow={
                                                                        product.auction === 1
                                                                            ? true
                                                                            : false
                                                                    }
                                                                    disabled={
                                                                        product?.market_status ===
                                                                            'closed' &&
                                                                        (product?.source_type ===
                                                                            'null' ||
                                                                            product?.buynow_source_type ===
                                                                                '')
                                                                    }
                                                                /> */}
                                                                <PrimaryButton
                                                                    id="finished"
                                                                    className="w-100"
                                                                    label="Finished"
                                                                    btnSize="small"
                                                                />
                                                            </div>
                                                            <div className="position-relative">
                                                                <>
                                                                    {product.custom_auctionlot_bid_type ===
                                                                    'hard' ? (
                                                                        <>
                                                                            <Bidding
                                                                                data={product}
                                                                                type={'hard'}
                                                                                disabled={
                                                                                    (product.market_status ===
                                                                                        'closed' ||
                                                                                        product.market_status ===
                                                                                            'relisted' ||
                                                                                        product.market_status ===
                                                                                            'unsold') &&
                                                                                    (product?.source_type ===
                                                                                        'buynow' ||
                                                                                        product?.buynow_source_type ===
                                                                                            '')
                                                                                }
                                                                            />{' '}
                                                                        </>
                                                                    ) : product.custom_auctionlot_bid_type ===
                                                                      'proxy' ? (
                                                                        <Bidding
                                                                            data={product}
                                                                            type={'proxy'}
                                                                            disabled={
                                                                                (product.market_status ===
                                                                                    'closed' ||
                                                                                    product.market_status ===
                                                                                        'relisted' ||
                                                                                    product.market_status ===
                                                                                        'unsold') &&
                                                                                (product?.source_type ===
                                                                                    'buynow' ||
                                                                                    product?.buynow_source_type ===
                                                                                        '')
                                                                            }
                                                                        />
                                                                    ) : (
                                                                        <>
                                                                            <Bidding
                                                                                data={product}
                                                                                type={'proxy'}
                                                                                disabled={
                                                                                    product.market_status ===
                                                                                        'closed' ||
                                                                                    product.market_status ===
                                                                                        'relisted' ||
                                                                                    product.market_status ===
                                                                                        'unsold'
                                                                                }
                                                                            />
                                                                            <div
                                                                                className={`timeBidding d-flex justify-content-between flex-wrap align-items-center ${
                                                                                    isHardOfferSelected &&
                                                                                    'flex-column-reverse position-relative'
                                                                                }`}
                                                                            >
                                                                                <div
                                                                                    className={`mt-0 timerConTent ${
                                                                                        isHardOfferSelected &&
                                                                                        'timerAfClass'
                                                                                    }`}
                                                                                >
                                                                                    {product.market_status ===
                                                                                    'open' ? (
                                                                                        <div className="gridTimer">
                                                                                            <img src="/assets/svg/timer.svg" />
                                                                                            <Timer
                                                                                                date_added={
                                                                                                    product.date_added
                                                                                                }
                                                                                                date_closed={
                                                                                                    product.date_closed
                                                                                                }
                                                                                                withText={
                                                                                                    1
                                                                                                }
                                                                                                endText="Time Left: "
                                                                                                startText="Starts in: "
                                                                                            ></Timer>
                                                                                        </div>
                                                                                    ) : (
                                                                                        <div className="gridTimer">
                                                                                            <img src="/assets/svg/timer-gray.svg" />
                                                                                            <label>
                                                                                                Closed
                                                                                            </label>
                                                                                        </div>
                                                                                    )}
                                                                                    <div className="dateTime mt-2 text-left">
                                                                                        (
                                                                                        {formatDate(
                                                                                            product.date_closed,
                                                                                        )}
                                                                                        )
                                                                                    </div>
                                                                                </div>
                                                                                <div
                                                                                    className={`asdasd ${
                                                                                        isHardOfferSelected &&
                                                                                        'w-100'
                                                                                    } ${
                                                                                        isMobileView &&
                                                                                        'w-100'
                                                                                    } biddingCounter`}
                                                                                >
                                                                                    <Bidding
                                                                                        data={
                                                                                            product
                                                                                        }
                                                                                        type={
                                                                                            'hard'
                                                                                        }
                                                                                        mobileViewLayout={
                                                                                            isMobileView
                                                                                                ? true
                                                                                                : false
                                                                                        }
                                                                                        productHard={
                                                                                            toggleHardOffer
                                                                                        }
                                                                                        disabled={
                                                                                            ((product.market_status ===
                                                                                                'closed' ||
                                                                                                product.market_status ===
                                                                                                    'relisted' ||
                                                                                                product.market_status ===
                                                                                                    'unsold') &&
                                                                                                (product?.source_type ===
                                                                                                    'buynow' ||
                                                                                                    product?.buynow_source_type ===
                                                                                                        '')) ||
                                                                                            product?.market_status !==
                                                                                                'open'
                                                                                        }
                                                                                    />
                                                                                    <div
                                                                                        className="pick-left-wrap d-flex justify-content-end"
                                                                                        style={{
                                                                                            minHeight:
                                                                                                isMobileView
                                                                                                    ? null
                                                                                                    : '37px',
                                                                                        }}
                                                                                    >
                                                                                        {isAuthenticated ? (
                                                                                            <>
                                                                                                {product.bidtopstatus ===
                                                                                                    'winner' &&
                                                                                                    isBidCanceAllowed() && (
                                                                                                        <>
                                                                                                            <div>
                                                                                                                <div className="text-right mt-2">
                                                                                                                    <Timer
                                                                                                                        date_added={
                                                                                                                            search_allbidhistory
                                                                                                                                .records[0]
                                                                                                                                .created_at
                                                                                                                        }
                                                                                                                        date_closed={substractMinutes(
                                                                                                                            product.date_closed,
                                                                                                                            product.custom_auctionlot_bid_retract_minutes,
                                                                                                                        )}
                                                                                                                        withText={
                                                                                                                            1
                                                                                                                        }
                                                                                                                        endText="Cancel By: "
                                                                                                                        startText="Starts in: "
                                                                                                                        closedText="Cancellation Expired"
                                                                                                                    ></Timer>
                                                                                                                </div>

                                                                                                                <Button
                                                                                                                    className="pvBidHistBtn btn my-2"
                                                                                                                    onClick={() =>
                                                                                                                        cancelBid()
                                                                                                                    }
                                                                                                                >
                                                                                                                    <span className="material-icons">
                                                                                                                        undo
                                                                                                                    </span>{' '}
                                                                                                                    {
                                                                                                                        'Cancel My Offer'
                                                                                                                    }
                                                                                                                </Button>
                                                                                                            </div>
                                                                                                        </>
                                                                                                    )}

                                                                                                <>
                                                                                                    {product.auction ? (
                                                                                                        <Button
                                                                                                            id="view_bid_history"
                                                                                                            className="pvBidHistBtn"
                                                                                                            onClick={() =>
                                                                                                                setBidHistoryValue(
                                                                                                                    product.id,
                                                                                                                )
                                                                                                            }
                                                                                                        >
                                                                                                            <img
                                                                                                                className="mr-2"
                                                                                                                src="/assets/svg/Gavel.svg"
                                                                                                            />{' '}
                                                                                                            {t(
                                                                                                                'offer history',
                                                                                                            )}
                                                                                                        </Button>
                                                                                                    ) : (
                                                                                                        ''
                                                                                                    )}
                                                                                                </>
                                                                                            </>
                                                                                        ) : (
                                                                                            <></>
                                                                                        )}
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </>
                                                                    )}
                                                                </>
                                                            </div>
                                                        </>
                                                    ) : null}
                                                </div>
                                            </div>
                                        </div>
                                        {/* <div className="product-info-head">
                                            <h4>Product Info</h4>
                                            <img src="/assets/svg/Info.svg" alt="" />
                                        </div> */}

                                        <div className="pvAccordian mt-2 mb-2 w-100">
                                            {/* <Accordion
                                                square
                                                expanded={expanded === 'panel1'}
                                                onChange={handleChange('panel1')}
                                            >
                                                <AccordionSummary
                                                    expandIcon={<ExpandMoreIcon />}
                                                    aria-controls="panel1d-content"
                                                    id="panel1d-header"
                                                >
                                                    <h6 className="accTitle">
                                                        Product Description
                                                    </h6>
                                                </AccordionSummary>
                                                <AccordionDetails>
                                                    <div
                                                        dangerouslySetInnerHTML={{
                                                            __html: product.desc_proc,
                                                        }}
                                                        className="pv-pro-descp"
                                                    ></div>
                                                </AccordionDetails>
                                            </Accordion> */}
                                            <div className="pc-loc-wrap">
                                                {/*<Accordion square defaultExpanded>
                                                <AccordionSummary>
                                                    */}
                                                <h6 className="accTitle">
                                                    <a className="accTitle d-flex align-items-center mb-4">
                                                        Pickup and Item Location
                                                    </a>
                                                </h6>
                                                {/*</AccordionSummary>
                                                <AccordionDetails>
                                                    */}
                                                <div className="product-details">
                                                    <p className="pick-loc mb-2">
                                                        <span className="mb-2">Pickup :</span>
                                                        <a
                                                            className="get-directions-link"
                                                            target="_blank"
                                                            href={`https://www.google.com/maps/search/?api=1&query=Google&query_place_id=${productLocation?.place_id}`}
                                                            rel="noreferrer"
                                                        >
                                                            {productLocation?.full_address || ''}
                                                        </a>{' '}
                                                        <span>(Click for open hours and map)</span>
                                                    </p>
                                                    {product?.bin_location ? (
                                                        <p className="pick-loc mb-0">
                                                            <span className="mb-2">
                                                                Item Location :
                                                            </span>
                                                            <span className="ml-2">
                                                                {product?.bin_location} {' > '}
                                                                {product?.item_id}
                                                            </span>
                                                        </p>
                                                    ) : null}
                                                </div>
                                                {/*</AccordionDetails> 
                                            </Accordion>*/}
                                            </div>
                                            <div className="pc-loc-wrap">
                                                <h6 className="accTitle">
                                                    <a className="accTitle d-flex align-items-center mb-4">
                                                        Pickup Deadline
                                                    </a>
                                                </h6>
                                                <div className="product-details">
                                                    {/*<div
                                                        dangerouslySetInnerHTML={{
                                                            __html: product?.pickup_deadline_text,
                                                        }}
                                                        className="pv-pro-descp"
                                                    ></div>*/}
                                                    <div className="pv-pro-descp">
                                                        Within {product.pickup_deadline_days}{' '}
                                                        calendar days of buy now purchase or
                                                        accepted offer{' '}
                                                    </div>
                                                </div>
                                            </div>
                                            {/* <Accordion
                                                square
                                                expanded
                                                onChange={handleChange('panel0')}
                                            >
                                                <AccordionSummary
                                                    expandIcon={<ExpandMoreIcon />}
                                                    aria-controls="panel0d-content"
                                                    id="panel0d-header"
                                                >
                                                    <h6 className="accTitle">
                                                        <a className="accTitle pickupDead position-relative">
                                                            Pickup Deadline
                                                        </a>
                                                    </h6>
                                                </AccordionSummary>
                                                <AccordionDetails>
                                                    <div className="product-details">
                                                        <div
                                                            dangerouslySetInnerHTML={{
                                                                __html: product?.pickup_deadline_text,
                                                            }}
                                                            className="pv-pro-descp"
                                                        ></div>
                                                    </div>
                                                </AccordionDetails>
                                            </Accordion> */}
                                            <Accordion
                                                square
                                                expanded={expanded === 'panel1'}
                                                onChange={handleChange('panel1')}
                                            >
                                                <AccordionSummary
                                                    expandIcon={<ExpandMoreIcon />}
                                                    aria-controls="panel1d-content"
                                                    id="panel1d-header"
                                                >
                                                    <h6 className="accTitle">Item Details</h6>
                                                </AccordionSummary>
                                                <AccordionDetails>
                                                    <div className="product-details">
                                                        {/* <TextField
                                                            variant="outlined"
                                                            className="mb-2"
                                                        /> */}
                                                        {parseInt(product.conditionTypeId, 10) && (
                                                            <div className="pvDescChild">
                                                                <label>Condition:</label>
                                                                <h6>
                                                                    {alldata_all_dropdown
                                                                        .filter(
                                                                            (values) =>
                                                                                parseInt(
                                                                                    values.id,
                                                                                    10,
                                                                                ) ===
                                                                                parseInt(
                                                                                    product.conditionTypeId,
                                                                                    10,
                                                                                ),
                                                                        )
                                                                        .map(
                                                                            (values) =>
                                                                                values.description,
                                                                        )}
                                                                </h6>
                                                            </div>
                                                        )}

                                                        {product.color_size && (
                                                            <div className="pvDescChild">
                                                                <label>Color/Size:</label>
                                                                <h6>{product.color_size}</h6>
                                                            </div>
                                                        )}
                                                        {product.scan_lpn_number && (
                                                            <div className="pvDescChild">
                                                                <label>LPN:</label>
                                                                <h6>{product.scan_lpn_number}</h6>
                                                            </div>
                                                        )}
                                                        <div className="pvDescChild">
                                                            <label>Item ID:</label>
                                                            <h6>
                                                                {product?.item_id || product.id}
                                                            </h6>
                                                        </div>
                                                        {product.material && (
                                                            <div className="pvDescChild">
                                                                <label>Material:</label>
                                                                <h6>{product.material}</h6>
                                                            </div>
                                                        )}

                                                        {parseInt(product.category, 10) ? (
                                                            <div className="pvDescChild">
                                                                <label>Category:</label>
                                                                <h6>
                                                                    {allCategory
                                                                        .filter(
                                                                            (values) =>
                                                                                parseInt(
                                                                                    values.id,
                                                                                    10,
                                                                                ) ===
                                                                                parseInt(
                                                                                    product.category,
                                                                                    10,
                                                                                ),
                                                                        )
                                                                        .map(
                                                                            (values) =>
                                                                                values.description,
                                                                        )}
                                                                </h6>
                                                            </div>
                                                        ) : null}

                                                        {(product.brand && (
                                                            <div className="pvDescChild">
                                                                <label>Brand:</label>
                                                                <h6>{product.brand}</h6>
                                                            </div>
                                                        )) ||
                                                            ''}

                                                        {(parseInt(product.manufacturer, 10) && (
                                                            <div className="pvDescChild f">
                                                                <label>Manufacturer:</label>
                                                                <h6>
                                                                    {alldata_all_dropdown
                                                                        .filter(
                                                                            (values) =>
                                                                                parseInt(
                                                                                    values.id,
                                                                                    10,
                                                                                ) ===
                                                                                parseInt(
                                                                                    product.manufacturer,
                                                                                    10,
                                                                                ),
                                                                        )
                                                                        .map(
                                                                            (values) =>
                                                                                values.description,
                                                                        )}
                                                                </h6>
                                                            </div>
                                                        )) ||
                                                            ''}
                                                        {product.item_detail && (
                                                            <div className="pvDescChild">
                                                                <label>Additional Details:</label>
                                                                <h6>{product.item_detail}</h6>
                                                            </div>
                                                        )}
                                                        {/* <DynamicView
                                                            product={product}
                                                            arrayValue={props.arrayValue}
                                                            updateLoading={updateLoading}
                                                        /> */}
                                                    </div>
                                                </AccordionDetails>
                                            </Accordion>
                                            <Accordion
                                                square
                                                expanded={expanded === 'panel2'}
                                                onChange={handleChange('panel2')}
                                            >
                                                <AccordionSummary
                                                    expandIcon={<ExpandMoreIcon />}
                                                    aria-controls="panel2d-content"
                                                    id="panel2d-header"
                                                >
                                                    <h6 className="accTitle">Return Policy</h6>
                                                </AccordionSummary>
                                                <AccordionDetails>
                                                    <div className="product-details">
                                                        <h5 className="mb-4">
                                                            {allConfigurationVariables.return_policy ||
                                                                ''}
                                                        </h5>
                                                        <p className="learnMore mb-0">Learn more</p>
                                                        <Link
                                                            to={'/terms-and-conditions'}
                                                            target="_blank"
                                                        >
                                                            <span className="terms">
                                                                Terms & Conditions
                                                            </span>
                                                        </Link>
                                                    </div>
                                                </AccordionDetails>
                                            </Accordion>
                                            <Accordion
                                                square
                                                expanded={expanded === 'panel3'}
                                                onChange={handleChange('panel3')}
                                            >
                                                <AccordionSummary
                                                    expandIcon={<ExpandMoreIcon />}
                                                    aria-controls="panel3d-content"
                                                    id="panel3d-header"
                                                >
                                                    <h6 className="accTitle">Seller Info</h6>
                                                </AccordionSummary>
                                                <AccordionDetails>
                                                    <div className="product-details">
                                                        <h5>
                                                            <a
                                                                className="sellerInDetails"
                                                                target="_blank"
                                                                href={`https://www.google.com/maps/search/?api=1&query=Google&query_place_id=${productLocation?.place_id}`}
                                                                rel="noreferrer"
                                                            >
                                                                {productLocation?.name}
                                                            </a>
                                                        </h5>
                                                    </div>
                                                    {productLocation?.phone && (
                                                        <div className="product-details">
                                                            <h5>
                                                                Contact: {productLocation?.phone}
                                                            </h5>
                                                        </div>
                                                    )}
                                                </AccordionDetails>
                                            </Accordion>
                                            <Accordion
                                                square
                                                expanded={expanded === 'panel4'}
                                                onChange={handleChange('panel4')}
                                            >
                                                <AccordionSummary
                                                    expandIcon={<ExpandMoreIcon />}
                                                    aria-controls="panel4d-content"
                                                    id="panel4d-header"
                                                >
                                                    <>
                                                        {isAuthenticated ? (
                                                            <h6 className="accTitle">
                                                                My Notes{' '}
                                                                {/* <img
                                                            className="ml-2 infoIcon"
                                                            src="/assets/svg/Info.svg"
                                                        /> */}
                                                            </h6>
                                                        ) : (
                                                            <h6 className="accTitle">
                                                                Login To Make Notes
                                                            </h6>
                                                        )}
                                                    </>
                                                </AccordionSummary>
                                                <AccordionDetails>
                                                    <div className="product-details">
                                                        <div className="commAns position-relative myNotes">
                                                            {notesFormik.values.id &&
                                                            notesFormik.values.notes !== ''
                                                                ? notesFormik.values.notes
                                                                : 'Add a Note'}
                                                            {/* {notesFormik.values.id ? (
                                                                <div
                                                                    className="editNote deleteNote"
                                                                    onClick={deleteNotes}
                                                                >
                                                                    <span className="material-icons">
                                                                        delete
                                                                    </span>
                                                                </div>
                                                            ) : null} */}
                                                            <div
                                                                className="editNote"
                                                                onClick={toggleNotes}
                                                            >
                                                                <span className="material-icons">
                                                                    {notesFormik.values.id &&
                                                                    notesFormik.values.notes !== ''
                                                                        ? 'edit'
                                                                        : 'add'}
                                                                </span>
                                                            </div>

                                                            {notesFormik.values.id &&
                                                            notesFormik.values.notes !== '' ? (
                                                                <>
                                                                    <div
                                                                        className="editNote"
                                                                        onClick={deleteNotes}
                                                                    >
                                                                        <span className="material-icons">
                                                                            delete
                                                                        </span>
                                                                    </div>
                                                                </>
                                                            ) : null}
                                                        </div>
                                                    </div>
                                                </AccordionDetails>
                                            </Accordion>
                                            <Accordion
                                                square
                                                // expanded={expanded === 'panel5'}
                                                // onChange={handleChange('panel5')}
                                            >
                                                <AccordionSummary
                                                // expandIcon={<ExpandMoreIcon />}
                                                // aria-controls="panel5d-content"
                                                // id="panel5d-header"
                                                >
                                                    <h6 className="accTitle">
                                                        <a
                                                            onClick={toggleQuestion}
                                                            className="accTitle d-flex align-items-center"
                                                        >
                                                            Ask a Question
                                                            <img
                                                                src="/assets/svg/Question.svg"
                                                                className="askQues ml-2"
                                                                alt=""
                                                            />
                                                        </a>
                                                    </h6>
                                                </AccordionSummary>
                                                {/* <AccordionDetails>
                                                    <div className="product-details commensSec">
                                                        <div className="pvDescChild">
                                                            {comments.length ? (
                                                                <>
                                                                    {comments.map((data) => (
                                                                        <Comment data={data} />
                                                                    ))}{' '}
                                                                </>
                                                            ) : (
                                                                <p>No Questions yet</p>
                                                            )}
                                                        </div>
                                                    </div>
                                                </AccordionDetails> */}
                                            </Accordion>
                                            {/* <Accordion square>
                                                <AccordionSummary>
                                                    <h6 className="accTitle">
                                                        <a
                                                            onClick={toggleQuestion}
                                                            className="accTitle d-flex align-items-center"
                                                        >
                                                            Ask a Question
                                                            <img
                                                                src="/assets/svg/Question.svg"
                                                                className="askQues ml-2"
                                                                alt=""
                                                            />
                                                        </a>
                                                    </h6>
                                                </AccordionSummary>
                                            </Accordion> */}
                                            {/* <Accordion
                                                square
                                                expanded={expanded === 'panel3'}
                                                onChange={handleChange('panel3')}
                                            >
                                                <AccordionSummary
                                                    expandIcon={<ExpandMoreIcon />}
                                                    aria-controls="panel2d-content"
                                                    id="panel2d-header"
                                                >
                                                    <h6 className="accTitle">Comments</h6>
                                                </AccordionSummary>
                                                <AccordionDetails>
                                                    <div className="product-details commensSec">
                                                        <div className="pvDescChild">
                                                            {comments.map((data) =>
                                                                data.reply_count >= 1 &&
                                                                data.last_reply ? (
                                                                    <Comment data={data} />
                                                                ) : (
                                                                    ''
                                                                ),
                                                            )}
                                                        </div>
                                                    </div>
                                                </AccordionDetails>
                                            </Accordion> */}
                                        </div>
                                    </>
                                    <CustomDialog
                                        className="askQuesModal"
                                        open={askQuestion}
                                        title={
                                            <div className="d-flex align-items-center justify-content-center askingQ">
                                                Ask a Question
                                                <IconButton onClick={toggleQuestion}>
                                                    <span className="material-icons">clear</span>
                                                </IconButton>
                                            </div>
                                        }
                                    >
                                        <h5>
                                            You are asking a question to Seller{' '}
                                            <b>The Community Exchange</b> about{' '}
                                            <b>{product.title}</b>
                                        </h5>

                                        <Comments
                                            product={product}
                                            toggleQuestion={toggleQuestion}
                                        />
                                    </CustomDialog>
                                    <CustomDialog
                                        open={notesQues}
                                        className="askQuesModal addNotesModal"
                                        title={
                                            <div className="d-flex align-items-center justify-content-center askingQ">
                                                {notesFormik.values.id ? 'Edit' : 'Add'} Your Notes
                                                <IconButton onClick={toggleNotes}>
                                                    <span className="material-icons">clear</span>
                                                </IconButton>
                                            </div>
                                        }
                                    >
                                        {mapData(projectNotes)}
                                        {isAuthenticated ? (
                                            <form
                                                onSubmit={notesFormik.handleSubmit}
                                                autoComplete="nofill"
                                            >
                                                <PrimaryButton
                                                    type="submit"
                                                    className="mt-3"
                                                    label="Submit"
                                                />
                                            </form>
                                        ) : (
                                            <PrimaryButton
                                                btnSize="mt-3"
                                                label="Login to Add Notes"
                                                onClick={handleLoginPopup}
                                            />
                                        )}
                                    </CustomDialog>
                                    <Modal
                                        open={isPickOpen}
                                        onClose={handleOpenPickup}
                                        aria-labelledby="modal-title"
                                        aria-describedby="modal-description"
                                    >
                                        <Box sx={pickStyle}>
                                            <Typography id="modal-description" sx={{ mt: 2 }}>
                                                <p>
                                                    The pickup deadline is the designated time frame
                                                    within which payment and pickup for items
                                                    purchased through &#34;Buy Now&#34; or accepted
                                                    offers must be completed. If payment and pickup
                                                    are not completed by the deadline, a restocking
                                                    fee will be applied, and the items will be
                                                    considered abandoned. Please note that no
                                                    refunds will be issued for abandoned items.
                                                </p>
                                                <p className="learnMore mb-0">Learn more</p>
                                                <Link href="/terms-and-conditions">
                                                    <span className="terms">
                                                        Terms & Conditions
                                                    </span>
                                                </Link>
                                            </Typography>
                                        </Box>
                                    </Modal>
                                </div>
                            </div>
                        </>
                    ) : null}
                </div>
            </div>
            {similarProducts.length > 0 && (
                <>
                    {props.pvModalSimilarItems ? (
                        ''
                    ) : (
                        <div className="similar-container">
                            <ProductsSlider
                                products={similarProducts}
                                pvSimilar
                                title="SIMILAR ITEMS"
                            />
                        </div>
                    )}
                </>
            )}
        </>
    )
}
export default ProductView
